/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1959b1db9d7d7f74dcc029cd008a599f>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "LinkExternal".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for links that open up a new tab as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const LinkExternalIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.688 2.5a.19.19 0 0 0-.188.188v6.624c0 .104.084.188.188.188h6.624a.19.19 0 0 0 .188-.187V8.5H11v.813C11 10.244 10.245 11 9.313 11H2.686A1.687 1.687 0 0 1 1 9.313V2.686C1 1.757 1.756 1 2.688 1H3.5v1.5zM5.75 1h4.5a.75.75 0 0 1 .75.75v4.5H9.5V3.56L5.53 7.53 4.47 6.47 8.44 2.5H5.75z" clip-rule="evenodd"/>`,
  type: 'utility'
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
LinkExternalIcon.displayName = 'LinkExternalIcon';
var _default = exports.default = LinkExternalIcon;